<script setup>
import { computed } from 'vue'
import { isEnglish } from '../i18n'

const props = defineProps({ modelValue: { type: Object, required: true }, compact: Boolean })
const emit = defineEmits(['update:modelValue'])
const modes = [
  { id: 'light', name: ['轻量','Light'], detail: ['约 10 分钟','About 10 min'], values: [5, 15, 5] },
  { id: 'standard', name: ['标准','Standard'], detail: ['约 25 分钟','About 25 min'], values: [15, 40, 10] },
  { id: 'intensive', name: ['强化','Intensive'], detail: ['约 45 分钟','About 45 min'], values: [25, 70, 20] },
  { id: 'custom', name: ['自定义','Custom'], detail: ['按你的节奏','Your own pace'], values: null },
]

function choose(mode) {
  const next = { ...props.modelValue, mode: mode.id }
  if (mode.values) [next.new_words, next.review_limit, next.dictation] = mode.values
  emit('update:modelValue', next)
}
function update(key, value) { emit('update:modelValue', { ...props.modelValue, mode: 'custom', [key]: Number(value) }) }
const estimate = computed(() => Math.max(5, Math.round(props.modelValue.new_words * .8 + props.modelValue.review_limit * .22 + props.modelValue.dictation * .35)))
</script>

<template>
  <div class="goal-picker">
    <div class="goal-modes">
      <button v-for="mode in modes" :key="mode.id" type="button" :class="['goal-mode', { active: modelValue.mode === mode.id }]" @click="choose(mode)">
        <b>{{ mode.name[isEnglish?1:0] }}</b><small>{{ mode.detail[isEnglish?1:0] }}</small>
        <small v-if="mode.values" class="goal-cost">{{isEnglish ? `About ${mode.values[0] * 10} reviews/day over time` : `坚持后每日复习约 ${mode.values[0] * 10} 词`}}</small>
      </button>
    </div>
    <div v-if="modelValue.mode === 'custom'" class="range-grid">
      <label><span><b>{{isEnglish?'New words':'新词'}}</b><output>{{ modelValue.new_words }}</output></span><input type="range" min="0" max="30" step="5" :value="modelValue.new_words" @input="update('new_words', $event.target.value)" /></label>
      <label><span><b>{{isEnglish?'Review limit':'复习上限'}}</b><output>{{ modelValue.review_limit }}</output></span><input type="range" min="10" max="100" step="10" :value="modelValue.review_limit" @input="update('review_limit', $event.target.value)" /></label>
      <label><span><b>{{isEnglish?'Dictation':'听写'}}</b><output>{{ modelValue.dictation }}</output></span><input type="range" min="5" max="30" step="5" :value="modelValue.dictation" @input="update('dictation', $event.target.value)" /></label>
    </div>
    <p v-if="modelValue.mode === 'custom'" class="goal-cost custom-cost">{{isEnglish?`About ${modelValue.new_words * 10} reviews/day over time`:`坚持后每日复习约 ${modelValue.new_words * 10} 词（新词 × 10）`}}</p>
    <div class="goal-summary"><span><b>{{ modelValue.new_words }}</b> {{isEnglish?'new':'新词'}}</span><span><b>{{ modelValue.review_limit }}</b> {{isEnglish?'review':'复习'}}</span><span><b>{{ modelValue.dictation }}</b> {{isEnglish?'dictation':'听写'}}</span><em>{{isEnglish?`About ${estimate} min`:`约 ${estimate} 分钟`}}</em></div>
  </div>
</template>

<style scoped>
/* 1:10 法则换算标注：muted 小字，继承现有 goal-mode 网格不另起布局 */
.goal-cost {
  font-size: 11px;
  line-height: 1.4;
  color: var(--muted);
}
.goal-mode.active .goal-cost {
  color: inherit;
  opacity: .75;
}
.custom-cost {
  margin: 0;
}
</style>
